import { render, staticRenderFns } from "./contractChange.vue?vue&type=template&id=51b8e02c&scoped=true&"
import script from "./contractChange.vue?vue&type=script&lang=js&"
export * from "./contractChange.vue?vue&type=script&lang=js&"
import style0 from "./contractChange.vue?vue&type=style&index=0&id=51b8e02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8e02c",
  null
  
)

export default component.exports